import React from 'react';

const ColumnWrapper = (props) => <div {...props} />;

export default ColumnWrapper;
